module.exports = __webpack_public_path__ + "static/media/thermal-hotspot.8497bc32.svg";